import React, { useState } from "react";

const InsertExcel = () => {

    const [uploadedExcel, setUploadedExcel] = useState<File | null>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setUploadedExcel(e.target.files[0]);
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!uploadedExcel) {
            alert("Please select an Excel file");
            return;
        }

        console.log("Uploading file:", uploadedExcel);
    };

    return (
        <div className="flex justify-center items-center  bg-gray-50">

            <div className="bg-white shadow-lg rounded-xl border border-gray-200 p-8 w-full ">

                <h2 className="text-xl font-semibold text-gray-700 text-center mb-6">
                    Upload Excel File 📊
                </h2>

                <form onSubmit={handleSubmit} className="space-y-5">

                    {/* File Upload */}
                    <div className="flex flex-col gap-2">

                        <label className="text-sm font-medium text-gray-600" htmlFor="exportExcel">
                            Select Excel File
                        </label>

                        <input
                            type="file"
                            id="exportExcel"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            className="block w-full text-sm text-gray-500 
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-lg file:border-0
                            file:text-sm file:font-semibold
                            file:bg-blue-50 file:text-blue-600
                            hover:file:bg-blue-100
                            cursor-pointer"
                        />

                        {uploadedExcel && (
                            <p className="text-xs text-green-600">
                                Selected: {uploadedExcel.name} ✅
                            </p>
                        )}

                    </div>

                    {/* Upload Button */}
                    <button
                        type="submit"
                        className="w-full py-2.5 bg-blue-600 text-white rounded-lg 
                        hover:bg-blue-700 transition duration-200"
                    >
                        Upload File
                    </button>

                </form>

            </div>

        </div>
    );
};

export default InsertExcel;